// removed by extract-text-webpack-plugin
module.exports = {"splash":"src-components-simple-ScreenButton----style-module---splash---vmVX_","games":"src-components-simple-ScreenButton----style-module---games---3Z3Ak","about":"src-components-simple-ScreenButton----style-module---about---1KhCv"};


//////////////////
// WEBPACK FOOTER
// ./src/components/simple/ScreenButton/style.module.css
// module id = 238
// module chunks = 168707334958949